import React, { useMemo } from "react";
import { Ptag } from "components/core";
import {
  InsuranePlanWrapper,
  Header,
  LinksWrapper,
  Link,
  Image,
  Footer,
  InsurerIcon,
  FooterElement,
  NewFooterDiv,
  FooterButton,
  LinkNew,
} from "./styles";
import InsuranceIcon from "assets/svgs/insurance.svg";
import GpaIcon from "assets/svgs/gpa_card_icon.svg";
import GtlIcon from "assets/svgs/gtl_card_icon.svg";
import OpdIcon from "assets/images/medicaldoctor.png";
import HealthCheckup from "assets/images/medical-checkup.png";
import gmc_product from "assets/svgs/product_gmc.svg";
import LinkIcon from "assets/svgs/arrorLinkBlack2.svg";
import WhiteLinkIcon from "assets/svgs/whiteArrow.svg";
import BlueLink from "assets/svgs/blueArrow.svg";
import { CASHLESS_CLAIM_URLS } from "../../constants";
import moment from "moment";
import { insurers } from "constants/businessConstant";
import { useNavigate } from "react-router";
import parental_cover from "assets/svgs/parental_cover.svg";
import top_up_health from "assets/svgs/topup_health.svg";

const InsurancePlanCard = ({ plan_detail, details, type }) => {
  const navigate = useNavigate();
  const insurerName =
    details &&
    details.service_provider &&
    details.service_provider &&
    details.service_provider.toUpperCase();
  const flexProduct = localStorage.getItem("flow");
  const openPolicyDoc = () => {
    window.open(details.policy_doc_url);
  };
  const openBenefitManual = () => {
    navigate(`/grade-setup/grade`, {
      state: { useplanId: details.userplan_id },
    });
    // window.open(details.employee_policy_doc_url);
    // window.open(
    //   "https://healthfront-kyc-docs.s3.ap-south-1.amazonaws.com/" +
    //     details.employee_policy_doc
    // );
  };
  const openClaimSupport = () => {
    navigate(`/claim-support`);
  };

  const icon = useMemo(() => {
    let blob = "";
    switch (type) {
      case "GPA":
        blob = GpaIcon;
        break;
      case "GMC":
        blob = gmc_product;
        break;
      case "GTL":
        blob = GtlIcon;
        break;
      case "OPD":
        blob = OpdIcon;
        break;
      case "HC":
        blob = HealthCheckup;
        break;
      case "CI":
        blob = HealthCheckup;
        break;
      case "top_up_health":
        blob = top_up_health;
        break;
      case "parental_cover":
        blob = parental_cover;
        break;
      case "health_insurance_parents":
        blob = parental_cover;
        break;
      case "health_insurance_parents_in_laws":
        blob = parental_cover;
        break;
      default:
        blob = InsuranceIcon;
        break;
    }
    return blob;
  }, [type]);
  const newBenefitManual = () => {
    window.open(details.employee_policy_doc_url);
  };

  const cashlessClaimHandler = () => {
    console.log("icici lombard");
    if (insurerName.includes("NIVA BUPA")) {
      window.open(CASHLESS_CLAIM_URLS.NIVA);
    } else if (insurerName.includes("KOTAK")) {
      window.open(CASHLESS_CLAIM_URLS.KOTAK);
    } else if (insurerName.includes("ICICI LOMBARD")) {
      window.open(CASHLESS_CLAIM_URLS.ICICI);
    } else if (insurerName.includes("GO_DIGIT")) {
      window.open(CASHLESS_CLAIM_URLS.DIGIT);
    } else if (insurerName.includes("TATA_AIG")) {
      window.open(CASHLESS_CLAIM_URLS.TATA);
    } else {
      window.open(CASHLESS_CLAIM_URLS.DEFAULT);
    }
  };

  return (
    <InsuranePlanWrapper>
      <div style={{ padding: "20px 24px 16px 24px" }}>
        <Header style={{ justifyContent: "space-between", height: "4rem" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <img src={icon} width="36px" />
            <Ptag
              fontSize="18px"
              fontWeight="500"
              color="#436AB2"
              marginLeft="1rem"
            >
              {plan_detail.title}
            </Ptag>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "0rem",
              justifyContent: "center",
              alignItems: "center",
              marginRight: "1rem",
            }}
          >
            <Ptag fontSize="8px" fontWeight="600" textAlign="center">
              POWERED BY
            </Ptag>
            <InsurerIcon src={details && details.service_provider_logo} />
          </div>
        </Header>
        {/* <div style={{ display: "flex", marginTop: "1rem" }}>
          <Ptag>Policy Number :&nbsp;</Ptag>
          <Ptag fontWeight="700"> {details.group_policy_number || "-"}</Ptag>
        </div> */}
        <Ptag
          fontSize="16px"
          fontWeight="400"
          marginTop="2rem"
          // marginBottom="1.2rem"
          letterHeight="24px"
          // maxWidth="75%"
        >
          {plan_detail.description}
        </Ptag>
      </div>
      <div>
        <LinksWrapper>
          {/* {details.policy_doc_url ? (
            <Link onClick={openPolicyDoc}>
              <Ptag fontSize="12px" fontWeight="600">
                Policy Schedule
              </Ptag>
              <Image src={LinkIcon} />
            </Link>
          ) : (
            <span></span>
          )} */}
          {details.employee_policy_doc_url && (
            <Link onClick={newBenefitManual}>
              <Ptag fontSize="14px" fontWeight="600" color="#0054E3">
                Employee Benefit Manual
              </Ptag>
              <Image src={BlueLink} />
            </Link>
          )}
          {
            // details.flat_or_graded === "GRADED" &&
            // <Link onClick={openBenefitManual}>
            //   <Ptag fontSize="12px" fontWeight="600">
            //     Plan Setup
            //   </Ptag>
            //   <Image src={LinkIcon} />
            // </Link>
          }
        </LinksWrapper>
        {/* <Footer>
          <NewFooterDiv>
            {details.policy_doc_url && (
              <Link onClick={openPolicyDoc}>
                <Ptag fontSize="12px" fontWeight="600" color="white">
                  Policy Schedule
                </Ptag>
                <Image src={LinkIcon} />
              </Link>
            )}
          </NewFooterDiv>
          <NewFooterDiv>
            {
              // details.flat_or_graded === "GRADED" &&
              <Link onClick={openBenefitManual}>
                <Ptag fontSize="12px" fontWeight="600" color="white">
                  Plan Setup
                </Ptag>
                <Image src={LinkIcon} />
              </Link>
            }
          </NewFooterDiv>
        </Footer> */}
        <FooterElement>
          <FooterButton style={{ borderBottomLeftRadius: "inherit" }}>
            {details.policy_doc_url && (
              <LinkNew onClick={openPolicyDoc} style={{ alignItems: "end" }}>
                <div style={{ maxWidth: "65%" }}>
                  <Ptag fontSize="14px" fontWeight="500" color="white">
                    Policy Schedule
                  </Ptag>
                </div>
                <Image src={WhiteLinkIcon} />
              </LinkNew>
            )}
          </FooterButton>
          {details.flat_or_graded !== "PER_EMPLOYEE" && <FooterButton
            style={{
              borderBottomRightRadius:
                plan_detail.title !== "Group Mediclaim Cover" ? "inherit" : "",
            }}
          >
            {
              // details.flat_or_graded === "GRADED" &&
              <LinkNew
                onClick={openBenefitManual}
                style={{ alignItems: "end" }}
              >
                <div style={{ maxWidth: "40%" }}>
                  <Ptag fontSize="14px" fontWeight="500" color="white">
                    Plan Overview
                  </Ptag>
                </div>
                <Image src={WhiteLinkIcon} />
              </LinkNew>
            }
          </FooterButton>}
          {[
            "Group Mediclaim Cover",
            "Group Top Up Health",
            "Group Parental Cover",
          ].includes(plan_detail.title) && (
            <FooterButton style={{ borderBottomRightRadius: "inherit" }}>
              {
                // details.flat_or_graded === "GRADED" &&
                <LinkNew
                  onClick={openClaimSupport}
                  style={{ alignItems: "end" }}
                >
                  <div style={{ maxWidth: "65%" }}>
                    <Ptag fontSize="14px" fontWeight="500" color="white">
                      Claims Support
                    </Ptag>
                  </div>
                  <Image src={WhiteLinkIcon} />
                </LinkNew>
              }
            </FooterButton>
          )}
        </FooterElement>
      </div>
    </InsuranePlanWrapper>
  );
};

export default InsurancePlanCard;
